export const finlandUniversities = {
  "university-of-helsinki": {
    slug: "university-of-helsinki", country: "finland",
    name: "University of Helsinki", shortName: "UH", flag: "🇫🇮",
    city: "Helsinki", founded: 1640, qsRank: "#117 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1517638851339-4aa32003c11a?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1496307653780-42ee777d4833?q=80&w=900&auto=format&fit=crop",
    overview: "Finland’s highest-ranked university known for research excellence in sciences, AI, medicine, and humanities.",
    tuition: { domestic: "€0 (EU)", international: "€13,000–€20,000/yr" },
    living: "€800–€1,300/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Computer Science", duration: "2 years", language: "English" },
      { name: "MSc Data Science", duration: "2 years", language: "English" },
      { name: "MSc Environmental Change", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "92%", avgSalary: "€38,000–€60,000", topEmployers: ["Nokia", "KONE", "Accenture"] },
    intakes: ["August", "January"], istpStudents: 16,
  },

  "aalto-university": {
    slug: "aalto-university", country: "finland",
    name: "Aalto University", shortName: "Aalto", flag: "🇫🇮",
    city: "Espoo", founded: 2010, qsRank: "#109 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=900&auto=format&fit=crop",
    overview: "Premier Finnish university for engineering, design, entrepreneurship, and technology innovation.",
    tuition: { domestic: "€0 (EU)", international: "€15,000–€25,000/yr" },
    living: "€850–€1,350/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [
      { name: "MSc Artificial Intelligence", duration: "2 years", language: "English" },
      { name: "MSc Mechanical Engineering", duration: "2 years", language: "English" },
      { name: "MBA", duration: "1 year", language: "English" },
    ],
    placementStats: { rate: "94%", avgSalary: "€42,000–€68,000", topEmployers: ["Nokia", "Supercell", "Wolt"] },
    intakes: ["August"], istpStudents: 14,
  },

  "tampere-university": {
    slug: "tampere-university", country: "finland",
    name: "Tampere University", shortName: "TAU", flag: "🇫🇮",
    city: "Tampere", founded: 2019, qsRank: "#462 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1494526585095-c41746248156?q=80&w=900&auto=format&fit=crop",
    overview: "Strong in engineering, signal processing, healthcare technology, and automation.",
    tuition: { domestic: "€0 (EU)", international: "€10,000–€18,000/yr" },
    living: "€700–€1,100/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [
      { name: "MSc Software Engineering", duration: "2 years", language: "English" },
      { name: "MSc Automation Engineering", duration: "2 years", language: "English" },
    ],
    placementStats: { rate: "90%", avgSalary: "€36,000–€55,000", topEmployers: ["Sandvik", "Nokia", "Valmet"] },
    intakes: ["August", "January"], istpStudents: 10,
  },

  "university-of-oulu": {
    slug: "university-of-oulu", country: "finland",
    name: "University of Oulu", shortName: "Oulu", flag: "🇫🇮",
    city: "Oulu", founded: 1958, qsRank: "#344 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1494526585095-c41746248156?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?q=80&w=900&auto=format&fit=crop",
    overview: "Known for wireless communications, 6G research, AI, and health sciences.",
    tuition: { domestic: "€0 (EU)", international: "€10,000–€16,000/yr" },
    living: "€650–€1,000/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [{ name: "MSc Wireless Communications", duration: "2 years", language: "English" }],
    placementStats: { rate: "89%", avgSalary: "€35,000–€54,000", topEmployers: ["Nokia", "VTT"] },
    intakes: ["August"], istpStudents: 8,
  },

  "university-of-turku": {
    slug: "university-of-turku", country: "finland",
    name: "University of Turku", shortName: "UTU", flag: "🇫🇮",
    city: "Turku", founded: 1920, qsRank: "#315 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1496307653780-42ee777d4833?q=80&w=900&auto=format&fit=crop",
    overview: "Popular for biotechnology, data analytics, and business studies.",
    tuition: { domestic: "€0 (EU)", international: "€10,000–€18,000/yr" },
    living: "€700–€1,050/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [{ name: "MSc Biotechnology", duration: "2 years", language: "English" }],
    placementStats: { rate: "88%", avgSalary: "€34,000–€52,000", topEmployers: ["Bayer", "Nordea"] },
    intakes: ["August"], istpStudents: 7,
  },

  "lut-university": {
    slug: "lut-university", country: "finland",
    name: "LUT University", shortName: "LUT", flag: "🇫🇮",
    city: "Lappeenranta", founded: 1969, qsRank: "#336 QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=900&auto=format&fit=crop",
    overview: "Strong in sustainability, energy systems, and technology management.",
    tuition: { domestic: "€0 (EU)", international: "€11,000–€15,000/yr" },
    living: "€650–€950/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [{ name: "MSc Energy Technology", duration: "2 years", language: "English" }],
    placementStats: { rate: "90%", avgSalary: "€36,000–€55,000", topEmployers: ["Fortum", "ABB"] },
    intakes: ["August"], istpStudents: 6,
  },

  "jyvaskyla-university": {
    slug: "jyvaskyla-university", country: "finland",
    name: "University of Jyväskylä", shortName: "JYU", flag: "🇫🇮",
    city: "Jyväskylä", founded: 1934, qsRank: "#446 QS World 2025",
    heroImg:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1600&auto=format&fit=crop",
    campusImg:
      "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?q=80&w=900&auto=format&fit=crop",
    overview: "Known for education sciences, psychology, and sports technology.",
    tuition: { domestic: "€0 (EU)", international: "€10,000–€14,000/yr" },
    living: "€650–€950/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [{ name: "MSc Education Leadership", duration: "2 years", language: "English" }],
    placementStats: { rate: "87%", avgSalary: "€32,000–€48,000", topEmployers: ["Schools", "Research Bodies"] },
    intakes: ["August"], istpStudents: 4,
  },

  "abo-akademi-university": {
    slug: "abo-akademi-university", country: "finland",
    name: "Åbo Akademi University", shortName: "ÅAU", flag: "🇫🇮",
    city: "Turku", founded: 1918, qsRank: "#601+ QS World 2025",
    heroImg: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1562774053-701939374585?q=80&w=900&auto=format&fit=crop",
    overview: "Swedish-language Finnish university strong in chemical engineering and IT.",
    tuition: { domestic: "€0 (EU)", international: "€10,000–€14,000/yr" },
    living: "€700–€1,050/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [{ name: "MSc Information Technology", duration: "2 years", language: "English" }],
    placementStats: { rate: "86%", avgSalary: "€32,000–€47,000", topEmployers: ["Regional Tech Firms"] },
    intakes: ["August"], istpStudents: 3,
  },

  "hanken-school-of-economics": {
    slug: "hanken-school-of-economics", country: "finland",
    name: "Hanken School of Economics", shortName: "Hanken", flag: "🇫🇮",
    city: "Helsinki", founded: 1909, qsRank: "#Top Business School",
    heroImg: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?q=80&w=900&auto=format&fit=crop",
    overview: "Specialised business school known for finance, analytics, and management.",
    tuition: { domestic: "€0 (EU)", international: "€12,500/yr" },
    living: "€850–€1,350/mo", ielts: "6.5+", gre: "Optional",
    topCourses: [{ name: "MSc Finance", duration: "2 years", language: "English" }],
    placementStats: { rate: "93%", avgSalary: "€42,000–€70,000", topEmployers: ["KPMG", "EY", "Nordea"] },
    intakes: ["August"], istpStudents: 5,
  },

  "vaasa-university": {
    slug: "vaasa-university", country: "finland",
    name: "University of Vaasa", shortName: "UVA", flag: "🇫🇮",
    city: "Vaasa", founded: 1968, qsRank: "#Top Emerging",
    heroImg: "https://images.unsplash.com/photo-1519452575417-564c1401ecc0?q=80&w=1600&auto=format&fit=crop",
    campusImg: "https://images.unsplash.com/photo-1564981797816-1043664bf78d?q=80&w=900&auto=format&fit=crop",
    overview: "Good choice for business analytics, energy systems, and industrial management.",
    tuition: { domestic: "€0 (EU)", international: "€12,000/yr" },
    living: "€650–€950/mo", ielts: "6.0+", gre: "Optional",
    topCourses: [{ name: "MSc Strategic Business Development", duration: "2 years", language: "English" }],
    placementStats: { rate: "88%", avgSalary: "€34,000–€50,000", topEmployers: ["ABB", "Wärtsilä"] },
    intakes: ["August"], istpStudents: 4,
  },
};